import { connect } from 'react-redux'
import Helmet from './Helmet'

const mapStateToProps = ({ topic }) => {
  const name = topic?.Tag?.Name || ''
  const slug = topic?.Tag?.Slug || ''
  const introduction = topic?.Tag?.Introduction || ''
  const metaTitle = topic?.Tag?.SeoTitle || ''
  const metaDescription = topic?.Tag?.SeoDescription || ''
  return {
    name,
    introduction,
    metaTitle,
    metaDescription,
    slug
  }
}

export default connect(mapStateToProps, null)(Helmet)
